<template>
  <div id="product" class="w-full flex-col">
    <hr />
    <h1 class="px-10 font-bold text-2xl md:text-5xl text-black py-3 md:py-6">
      Produk
    </h1>
    <div class="flex flex-row px-10">
      <div class="rectangle-23 bg-green-fluorescent mt-1 mr-3"></div>
      <div class="w-full h-34 md:h-20">
        <p class="font-medium text-md md:text-xl">
          Hasil pertanian merupakan tunjang utama dalam meningkatkan ekonomi
          koperasi ini. Tanaman kelapa sawit, kelapa tacunan, dan penghasilan
          bibit tanaman antara contoh utama yang giat diusahakan.
        </p>
      </div>
    </div>
    <div
      class="w-full px-10 py-10 pb-15 flex flex-col md:flex-row grid grid-rows-1 md:grid-cols-3 gap-4"
    >
      <div
        v-for="product in mergedProducts"
        :key="product.id"
        class="rounded-3xl shadow"
      >
        <div
          class="h-80 w-full rounded-t-3xl bgNoRepeatImage"
          v-bind:style="getProductImageStyle(product)"
        ></div>
        <div class="h-1/6 flex justify-center py-5">
          <h1 class="font-semibold text-xl">{{ product.name }}</h1>
        </div>
      </div>
    </div>
    <!-- <div
      class="h-0 md:h-screen px-10 w-full bg-cover bg-center"
      v-bind:style="imageQuote"
    ></div> -->
    <div class="px-10 w-full h-34 md:h-20">
      <p class="font-medium text-md md:text-xl">
        Sila 
        <router-link
          class="inline-block px-2 py-1 border border-green-500 text-green-500 font-medium text-md rounded hover:bg-green-500 hover:text-white transition-colors duration-300"
          to="/contact"
          >hubungi kami</router-link
        >
        untuk mendapatkan anak benih yang tersedia. Sebarang pertanyaan boleh di
        lakukan.
      </p>
    </div>
  </div>
</template>

<script>
import { listAll, ref, getDownloadURL } from "firebase/storage";
import { storage } from "@/firebase/db";

export default {
  name: "Product",
  data() {
    return {
      firebaseProducts: [],
      loading: false,
      defaultProducts: [
        {
          id: "anak-benih-sawit",
          name: "Anak Benih Sawit",
          imageUrl: require("@/assets/images/anak-benih-sawit.jpeg"),
          isDefault: true,
        },
        {
          id: "anak-benih-kelapa-pandan",
          name: "Anak Benih Kelapa Pandan",
          imageUrl: require("@/assets/images/kelapa-pandan.jpeg"),
          isDefault: true,
        },
        {
          id: "anak-benih-musang-king",
          name: "Anak Benih Musang King",
          imageUrl: require("@/assets/images/Durian.jpg"),
          isDefault: true,
        },
        {
          id: "anak-benih-avocado",
          name: "Anak Benih Avocado",
          imageUrl: require("@/assets/images/Avocado-2.jpg"),
          isDefault: true,
        },
        {
          id: "anak-benih-kelapa-tacunan",
          name: "Anak Benih Kelapa Tacunan",
          imageUrl: require("@/assets/images/benih-tacunan.jpg"),
          isDefault: true,
        },
        {
          id: "anak-benih-nangka",
          name: "Anak Benih Nangka",
          imageUrl: require("@/assets/images/Nangka-J33.jpg"),
          isDefault: true,
        },
      ],
    };
  },
  computed: {
    mergedProducts() {
      return this.mergeProducts();
    },
    kelapaPandan() {
      return require("@/assets/images/kelapa-pandan.jpeg");
    },
    kelapaSawit() {
      return require("@/assets/images/anak-benih-sawit.jpeg");
    },
    musangKing() {
      return require("@/assets/images/Durian.jpg");
    },
    kelapaTacunan() {
      return require("@/assets/images/benih-tacunan.jpg");
    },
    avocado() {
      return require("@/assets/images/Avocado-2.jpg");
    },
    jackfruit() {
      return require("@/assets/images/Nangka-J33.jpg");
    },
    projekNenas() {
      return require("@/assets/images/projek-nenas.jpeg");
    },
    quote() {
      return require("@/assets/images/quote-banner.png");
    },
    imageKelapaPandan() {
      return {
        background: `url(${this.kelapaPandan})`,
        backgroundSize: "cover !important",
        display: "block",
      };
    },
    imageKelapaSawit() {
      return {
        background: `url(${this.kelapaSawit})`,
        backgroundSize: "cover !important",
        display: "block",
      };
    },
    imageMusangKing() {
      return {
        background: `url(${this.musangKing})`,
        backgroundSize: "cover !important",
        display: "block",
      };
    },
    imageAvocado() {
      return {
        background: `url(${this.avocado})`,
        backgroundSize: "cover !important",
        display: "block",
      };
    },
    imageTacunan() {
      return {
        background: `url(${this.kelapaTacunan})`,
        backgroundSize: "cover !important",
        display: "block",
      };
    },
    imageJackfruit() {
      return {
        background: `url(${this.jackfruit})`,
        backgroundSize: "cover !important",
        display: "block",
      };
    },
    imageQuote() {
      return {
        background: `url(${this.quote})`,
        backgroundSize: "cover !important",
      };
    },
  },
  methods: {
    convertFolderNameToDisplayName(folderName) {
      // Convert kebab-case to Title Case
      // e.g., "anak-benih-sawit" -> "Anak Benih Sawit"
      return folderName
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    normalizeProductName(name) {
      // Normalize product name for comparison (lowercase, remove spaces/hyphens)
      return name.toLowerCase().replace(/[\s-]/g, "");
    },
    async fetchFirebaseProducts() {
      this.loading = true;
      try {
        const productsRef = ref(storage, "products");
        const folders = await listAll(productsRef);

        const productPromises = folders.prefixes.map(async (folderRef) => {
          try {
            // List all files in the product folder
            const files = await listAll(folderRef);

            // Find the first image file (jpg, jpeg, png, webp)
            const imageExtensions = [".jpg", ".jpeg", ".png", ".webp"];
            const imageFile = files.items.find((item) => {
              const fileName = item.name.toLowerCase();
              return imageExtensions.some((ext) => fileName.endsWith(ext));
            });

            if (imageFile) {
              const downloadURL = await getDownloadURL(imageFile);
              const folderName = folderRef.name;
              const displayName = this.convertFolderNameToDisplayName(folderName);

              return {
                id: folderName,
                name: displayName,
                imageUrl: downloadURL,
                isDefault: false,
              };
            }
            return null;
          } catch (error) {
            console.error(`Error fetching product from ${folderRef.name}:`, error);
            return null;
          }
        });

        const products = await Promise.all(productPromises);
        this.firebaseProducts = products.filter((product) => product !== null);
      } catch (error) {
        console.error("Error fetching Firebase products:", error);
        // Fallback to default products if Firebase fetch fails
        this.firebaseProducts = [];
      } finally {
        this.loading = false;
      }
    },
    mergeProducts() {
      // Create a map of Firebase products by normalized name
      const firebaseMap = new Map();
      this.firebaseProducts.forEach((product) => {
        const normalizedName = this.normalizeProductName(product.name);
        firebaseMap.set(normalizedName, product);
      });

      // Filter out default products that have a matching Firebase product
      const defaultProductsToShow = this.defaultProducts.filter((defaultProduct) => {
        const normalizedName = this.normalizeProductName(defaultProduct.name);
        return !firebaseMap.has(normalizedName);
      });

      // Return Firebase products first, then default products
      return [...this.firebaseProducts, ...defaultProductsToShow];
    },
    getProductImageStyle(product) {
      return {
        background: `url(${product.imageUrl})`,
        backgroundSize: "cover !important",
        display: "block",
      };
    },
  },
  async created() {
    await this.fetchFirebaseProducts();
  },
};
</script>

<style>
.bg-green-fluorescent {
  background-color: #94de2a;
}
.shadow {
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.16);
}
.rectangle-220 {
  border-radius: 20px;
}
.bgNoRepeatImage {
  background-repeat: no-repeat;
}
</style>